<template>
  <div>
    <div>
      <el-form :model="ruleForm" ref="ruleForm" label-width="150px" class="demo-ruleForm">
        <el-form-item
          label="Email"
          prop="email"
          :rules="[{
            required: true,
            message: 'Please enter the E-mail!',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Please enter the correct email address',
            trigger: ['blur', 'change'],
          }]"
        >
          <el-input v-model="ruleForm.email" oninput="if(value){value=value.toLowerCase()}" onblur="if(value){value=value.trim()}">
          </el-input>
        </el-form-item>
        <el-form-item
          label="Verification Code"
          prop="verifyCode"
          :rules="{
            required: true,
            message: 'Please enter the E-mail verification code!',
            trigger: 'blur'
          }"
        >
        <div class="flex">
          <el-input v-model="ruleForm.verifyCode"></el-input>
          <el-button @click="getCaptcha" style="width: 100px;">{{timeValue}}</el-button>
        </div>

        </el-form-item>
        <el-form-item :wrapperCol="{ span: 19, offset: 5 }">
          <el-button type="primary" class="btn" @click="nextStepHandle('ruleForm')">Next</el-button></el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {getAction} from '@/api/manage.js'

export default {
  name: 'Step2',
  props: ['userList', 'nextStep'],
  data() {
    return {
      timeValue: 'Send',
      ruleForm: {
        email: '',
        verifyCode: ''
      },
      loading: false
    }
  },
  computed: {},
  methods: {
    nextStepHandle(type) {
      let that = this
      that.loading = true

      this.$refs[type].validate(valid => {
        if (valid) {
          getAction('/sys/user/passwordChange', this.ruleForm).then(res => {
            if (res.success) {
              that.$emit('nextStep', this.ruleForm)
            } else {
              this.$message.warning('Verification code error')
              that.loading = false
            }
          })
        } else {
          return false
        }
      })
    },
    getCaptcha(e) {
      e.preventDefault()
      let that = this

      if (this.ruleForm.email == '') {
        this.$message('E-mail cannot be empty!')
        return
      }

      let timeValue = this.timeValue

      //add by cpgu 添加幂等 2023/11/29 begin
      if (!isNaN(parseInt(timeValue)) && parseInt(timeValue) != 0) {
        console.log("60秒后重试")
        return;
      }
      //end by cpgu

      let time = 60
      let interval = window.setInterval(() => {
        time--
        if (time <= 0) {
          time = 60
          that.timeValue = timeValue
          window.clearInterval(interval)
        } else {
          that.timeValue = time
        }
      }, 1000)

      let smsParams = {
        email: this.ruleForm.email,
        msgType: '2'
      }
      getAction('/sys/user/sendEmailMsg', smsParams).then(res => {
        if (res.success) {

        }
      })
    },

    validatePhone(rule, value, callback) {
      if (value) {
        var myreg = /^[A-Zel-z\d]+([-_.][A-Zel-z\d]+)*@([A-Zel-z\d]+[-.])+[A-ZA-z\d]{2,4}$/
        if (!myreg.test(value)) {
          callback('E-mail error')
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.stepFormText {
  margin-bottom: 24px;
}
.flex{
  display: flex;
  width: 60%;
}

.btn{
  display: block;
  color: #262613;
  background: #F3E93D;
  border-color: #E1E1E1;
}
// .ant-form-item-label,
// .ant-form-item-control {
//   line-height: 22px;
// }

.getCaptcha {
  display: block;
  width: 100%;
  height: 40px;
}
.ant-input-affix-wrapper {
  padding: 0px;
}
.goto-login {
  float: left;
  line-height: 40px;
}
@media screen and (max-width: 420px) {
  .parent {
    position: static;
  }
  .logo-img {
    left: 0;
    margin-top: -140px;
    position: static;
  }
  .ant-divider.ant-divider-horizontal {
    width: 100%;
  }
  .ant-steps.ant-steps-horizontal.ant-steps-label-horizontal {
    margin-top: 0px;
  }
  /deep/ .ant-col-6 {
    width: 31%;
  }
  /deep/ .ant-col-18 {
    width: 60%;
  }
  /deep/ .ant-col.ant-col-6.ant-form-item-label {
    margin-top: 10px;
  }
  .phone-input {
    width: 100%;
  }
  /deep/ .ant-col-12 {
    width: 66%;
  }
  .goto-login {
    margin-left: -25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/forget/Step2.vue